import { useRef } from "react";
import { Quote, ArrowLeft, ArrowRight } from "lucide-react";
import { Reveal } from "./Motion";
import { TESTIMONIALS } from "../data/portfolio";

export default function Testimonials() {
  const trackRef = useRef(null);
  if (!TESTIMONIALS.length) return null;

  const scrollByCard = (dir) => () => {
    const el = trackRef.current;
    if (!el) return;
    const card = el.querySelector("[data-card]");
    const amount = card ? card.offsetWidth + 24 : el.clientWidth * 0.85;
    el.scrollBy({ left: dir * amount, behavior: "smooth" });
  };

  return (
    <section className="relative py-24 md:py-36 scroll-mt-20" data-testid="testimonials">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal className="flex items-end justify-between gap-6 mb-10 md:mb-12">
          <p className="text-xs uppercase tracking-[0.3em] text-white/40">In their words</p>
          <div className="flex gap-3">
            <button
              onClick={scrollByCard(-1)}
              data-testid="testimonial-prev"
              aria-label="Previous testimonials"
              className="w-11 h-11 rounded-full border border-white/20 flex items-center justify-center text-white/70 hover:bg-white hover:text-black transition-colors duration-300"
            >
              <ArrowLeft size={18} />
            </button>
            <button
              onClick={scrollByCard(1)}
              data-testid="testimonial-next"
              aria-label="Next testimonials"
              className="w-11 h-11 rounded-full border border-white/20 flex items-center justify-center text-white/70 hover:bg-white hover:text-black transition-colors duration-300"
            >
              <ArrowRight size={18} />
            </button>
          </div>
        </Reveal>

        <div
          ref={trackRef}
          data-testid="testimonial-track"
          style={{ scrollbarWidth: "none" }}
          className="flex gap-6 overflow-x-auto snap-x snap-mandatory pb-2 -mx-6 px-6 md:-mx-12 md:px-12 [&::-webkit-scrollbar]:hidden"
        >
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={t.author}
              data-card
              data-testid={`testimonial-quote-${i}`}
              className="snap-start shrink-0 w-[86%] sm:w-[430px] rounded-2xl border border-white/10 bg-[#0A0A0A] p-9 md:p-10 flex flex-col hover:border-white/20 transition-colors duration-500"
            >
              <Quote size={26} className="text-white/25 mb-5" aria-hidden />
              <blockquote className="leading-relaxed text-lg md:text-xl text-white/85 flex-1">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-7 text-xs uppercase tracking-[0.2em] text-white/40" data-testid={`testimonial-author-${i}`}>
                {t.author} · {t.org}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
